import { getQaItems } from '../data/interviews';
import {
  createEmptyInterview,
  DEFAULT_INTERVIEW_QA
} from '../schemas/interviewSchema';

const padNum = (index) => String(index + 1).padStart(2, '0');

const LEGACY_ARTICLE_KEYS = [
  'currentWork',
  'careerBefore',
  'joiningReason',
  'afterJoining',
  'flaretechStyle',
  'message'
];

export function toCmsInterview(data = {}) {
  const empty = createEmptyInterview();
  const sourceQa = Array.isArray(data.qa) && data.qa.length > 0 ? data.qa : getQaItems(data);
  const qa = (sourceQa.length > 0 ? sourceQa : DEFAULT_INTERVIEW_QA).map((item, index) => ({
    id: item.id || `q-${index + 1}`,
    num: item.num || padNum(index),
    heading: item.heading || '',
    lead: item.lead || '',
    body: item.body || '',
    image: item.image || '',
    pullQuote: item.pullQuote || '',
    extraLead: item.extraLead || '',
    extraBody: item.extraBody || ''
  }));

  const cmsInterview = { ...empty };
  Object.keys(empty).forEach((key) => {
    if (
      data[key] === undefined ||
      key === 'qa' ||
      key === 'photos' ||
      key === 'skillGrowth' ||
      key === 'keywords' ||
      key === 'techStack' ||
      key === 'certifications'
    ) {
      return;
    }
    cmsInterview[key] = data[key];
  });

  cmsInterview.qa = qa;
  cmsInterview.photos = (data.photos || [])
    .map((item) => (typeof item === 'string' ? item : item?.src || ''))
    .filter(Boolean);
  cmsInterview.keywords = data.keywords || [];
  cmsInterview.techStack = data.techStack || [];
  cmsInterview.certifications = data.certifications || [];
  cmsInterview.skillGrowth = !data.skillGrowth || Array.isArray(data.skillGrowth) ? null : data.skillGrowth;

  LEGACY_ARTICLE_KEYS.forEach((key) => {
    delete cmsInterview[key];
  });

  return cmsInterview;
}
